import {
    CREATE_OR_UPDATE_SEARCH_SUGGESTION,
    CREATE_OR_UPDATE_SEARCH_SUGGESTION_ERROR,
    CREATE_OR_UPDATE_SEARCH_SUGGESTION_RESET,
    CREATE_OR_UPDATE_SEARCH_SUGGESTION_SUCCESS,
    GET_SEARCH_SUGGESTIONS,
    GET_SEARCH_SUGGESTIONS_ERROR,
    GET_SEARCH_SUGGESTIONS_SUCCESS
} from "../actions/searchSuggestionAction";

const initialState = {
    searchSuggestionsData: {},
    searchSuggestionsLoading: {},
    searchSuggestionsError: {},

    data: {},
    saving: false,
    error: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CREATE_OR_UPDATE_SEARCH_SUGGESTION:
            return {
                ...state,
                saving: true,
                error: null,
            };

        case CREATE_OR_UPDATE_SEARCH_SUGGESTION_SUCCESS:
            return {
                ...state,
                saving: false,
                data: action.payload.success,
            };

        case CREATE_OR_UPDATE_SEARCH_SUGGESTION_ERROR:
            return {
                ...state,
                saving: false,
                error: action.payload.error,
                data: {},
            };

        case CREATE_OR_UPDATE_SEARCH_SUGGESTION_RESET:
            return {
                ...state,
                saving: false,
                error: null,
                data: {},
            };

        case GET_SEARCH_SUGGESTIONS:
            return {
                ...state,
                searchSuggestionsLoading: true,
                searchSuggestionsError: null,
            };

        case GET_SEARCH_SUGGESTIONS_SUCCESS:
            return {
                ...state,
                searchSuggestionsLoading: false,
                searchSuggestionsData: action.payload.success,
            };

        case GET_SEARCH_SUGGESTIONS_ERROR:
            return {
                ...state,
                searchSuggestionsLoading: false,
                searchSuggestionsError: action.payload.error,
                searchSuggestionsData: [],
            };

        default:
            return state;
    }
}